<template>
  <div>
    <y-header>
      {{title}}
      <button slot="right" :disabled="submitDisabled" @click="onSubmit" class="header-btn" :class="{disabled: submitDisabled}">提交</button>
    </y-header>
    <div name="scroll" :style="{overflow: 'auto', height: pageHeight + 'px', paddingTop: '40px'}" v-if="loading" class="yxy-fix-safari-overflow-scrolling">
      <y-progress v-model="progress"></y-progress>
    </div>
    <div name="scroll" :style="{overflow: 'auto', height: pageHeight + 'px', paddingTop: '40px'}" v-if="!loading" class="yxy-fix-safari-overflow-scrolling">
      <template v-for="item in questItemList">
        <quest-item-input v-if="item.type==='input'"
          v-model="questItemData[item.key]"
          :key="item.key"
          ref="input"
          :role="role"
          :title="item.title"
          :items="item.items"
          :hideTitle="item.hideTitle"
          :triggeredItems="item.triggeredItems"
          :calcScore="item.calcScore"
          @on-change="onChange"></quest-item-input>
        <quest-item-sselect v-if="item.type==='sselect' || item.type==='sselect_inline'"
          v-model="questItemData[item.key]"
          :key="item.key"
          ref="sselect"
          :inline="item.type==='sselect_inline'"
          :role="role"
          :title="item.title"
          :items="item.items"
          :required="item.required"
          :triggeredItems="item.triggeredItems"
          :scoreIndex="item.scoreIndex"
          @on-change="onChange"></quest-item-sselect>
        <quest-item-sselect-show v-if="item.type==='sselect_show_quest'"
          v-model="questItemData[item.key]"
          :key="item.key"
          ref="sselectShow"
          :inline="item.type==='sselect_inline'"
          :role="role"
          :title="item.title"
          :items="item.items"
          :questId="questId"
          :patientId="patientId"
          :crfId="crfId"
          :triggeredItems="item.triggeredItems"
          @on-data-change="onQuestItemListDataChange"
          @on-change="onChange"></quest-item-sselect-show>
        <quest-item-mselect v-if="item.type==='mselect'"
          v-model="questItemData[item.key]"
          :key="item.key"
          ref="mselect"
          :role="role"
          :title="item.title"
          :items="item.items"
          :required="item.required"
          :triggeredItems="item.triggeredItems"
          @on-change="onChange"></quest-item-mselect>
        <quest-item-mselect-input v-if="item.type==='mselect_input'"
          v-model="questItemData[item.key]"
          :key="item.key"
          ref="mselectInput"
          :role="role"
          :title="item.title"
          :items="item.items"
          :required="item.required"
          :triggeredItems="item.triggeredItems"
          @on-change="onChange"></quest-item-mselect-input>
        <quest-item-show v-if="item.type==='show'"
          v-model="questItemData[item.key]"
          :key="item.key"
          :role="role"
          :title="item.title"
          :items="item.items"
          :triggeredItems="item.triggeredItems"
          @on-change="onShowChange"></quest-item-show>
      </template>
      <div class="submit-footer" v-show="showSubmitBtn">
        <y-button type="primary" :disabled="submitDisabled" @click.native.stop="onSubmit">提交</y-button>
      </div>
    </div>
    <loading :show="showLoading" :text="loadingText"></loading>
    <toast v-model="showToast" :text="toastText" :type="toastType" @on-hide="onToastHide"></toast>
    <confirm v-model="showConfirm" content="确定放弃提交数据？"
      @on-confirm="onConfirmOk" @on-cancel="onConfirmCancel"></confirm>
  </div>
</template>

<script>
import {
  QuestItemInput,
  QuestItemSselect,
  QuestItemSselectShow,
  QuestItemMselect,
  QuestItemMselectInput,
  QuestItemShow
} from '../../lib/questlib-mobile'
// Vue全局注册防止递归引用render, 供quest-item-list中使用, quest-item-list不再局部注册quest-item-sselect-show
// 因quest-item-sselect-show中使用了quest-item-list
import Vue from 'vue'
Vue.component('QuestItemSselectShow', QuestItemSselectShow)

import { authenticate, catchExpired } from '../utils/auth'
import { getStorageItem, updateStorageItem } from '../utils/cache'
import YHeader from './common/y-header'
import YButton from './common/y-button'
import YProgress from './common/y-progress'
import Toast from './common/toast'
import Loading from './common/loading'
import Confirm from './common/confirm'
// import QuestItemInput from './question/quest-item-input'
// import QuestItemSselect from './question/quest-item-sselect'
// import QuestItemSselectShow from './question/quest-item-sselect-show'
// import QuestItemMselect from './question/quest-item-mselect'
// import QuestItemMselectInput from './question/quest-item-mselect-input'
// import QuestItemShow from './question/quest-item-show'
import Emitter from './mixins/emitter-async'
import formDisabled from './mixins/formDisabled'
import equal from './mixins/equal'
import { isMiniProgram } from '../utils/isMiniProgram'

export default {
  name: 'QuestItemList',
  mixins: [Emitter, formDisabled, equal],
  data () {
    return {
      progress: 0,
      loading: true,
      showLoading: false,
      showToast: false,
      showConfirm: false,
      loadingText: '提交中...',
      toastText: '未完成选择或填写',
      toastType: 'warn',
      submitDisabled: this.getDisabled(),
      role: '',
      title: '',
      crfId: '',
      questId: '',
      patientId: '',
      modelId: '',
      valueId: '',
      collection: '',
      questItemList: [],
      questItemData: {},
      questItemDataInital: {},
      hasDataChange: false,
      hasSubmitSuccess: false,
      backCount: 0,
      cancelSubmit: false,
      hasScore: false,
      showSubmitBtn: false
    }
  },
  computed: {
    pageHeight () {
      return this.$store.getters.getWinHeight - 40
    }
  },
  watch: {
    role (val) {
      this.submitDisabled = this.getDisabled()
    }
  },
  created () {
    this.$on('on-score-change', (score) => {
      this.broadcast('ShowScore', 'on-score-update', score)
    })
    this.$on('on-trigger', (triggerId, status) => {
      this.broadcast('QuestItemMselectInput', 'on-triggered', triggerId, status)
    })
  },
  beforeRouteEnter (to, from, next) {
    document.title = '填写随访'
    next(vm => {
      let params = getStorageItem('questitemlistParams')
      vm.crfId = to.query.crfId || params.crfId
      vm.questId = to.query.questId || params.questId
      vm.modelId = to.query.modelId || params.modelId
      vm.valueId = to.query.valueId || vm.getValueIdFromCache(vm.modelId, vm.questId)
      vm.collection = to.query.collection || params.collection
      vm.title = to.query.title ? decodeURI(to.query.title) : params.title
      vm.role = to.query.role || params.role
      vm.hasScore = to.query.hasScore ? to.query.hasScore === 'true' : params.hasScore === 'true'
      vm.loadItemList()
      vm.loadItemData()
    })
  },
  beforeRouteLeave (to, from, next) {
    if (!this.hasDataChange) {
      next()
    } else if (!this.hasSubmitSuccess && this.backCount === 0) {
      this.toastText = '还未提交数据'
      this.showToast = true
      this.backCount++
      next(false)
    } else if (!this.hasSubmitSuccess && this.backCount === 1 && !this.cancelSubmit) {
      this.showConfirm = true
      next(false)
    } else if (!this.hasSubmitSuccess && this.backCount === 1 && this.cancelSubmit) {
      next()
    } else {
      next()
    }
  },
  methods: {
    onConfirmOk () {
      this.cancelSubmit = true
      if (isMiniProgram()) {
        window.wx.miniProgram.navigateBack()
      } else {
        this.$router.back()
      }
    },
    onConfirmCancel () {
      this.cancelSubmit = false
      this.backCount = 0
    },
    onToastHide () {
      if (this.toastType === 'success') {
        if (isMiniProgram()) {
          window.wx.miniProgram.navigateBack()
        } else {
          this.$router.back()
        }
      }
    },
    loadItemList () {
      this.$http.get(`${this.httpRoot}/crf/crfTable/field/list`,
        authenticate({params: {id: this.modelId, crfId: this.crfId}}))
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          this.questItemList = res.fieldList || []
          this.showSubmitBtn = true
          this.progress = 100
          this.loading = false
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    },
    loadItemData () {
      this.$http.get(`${this.httpRoot}/followup/data/detail`,
        authenticate({params: {collection: this.collection, valueId: this.valueId}}))
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          // this.loading = false
          this.$nextTick(() => {
            this.questItemDataInital = this.deepCopy(res.itemData)
            this.questItemData = res.itemData
          })
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    },
    onShowChange (val) {
      console.log('on-show-change')
      // console.log(this.questItemData, val)
      this.hasDataChange = !this.equals(this.questItemData, this.questItemDataInital)
    },
    onChange (val) {
      // console.log(this.questItemData, val)
      this.hasDataChange = !this.equals(this.questItemData, this.questItemDataInital)
      if (this.hasScore) {
        let score = this.getScore()
        // console.log('score is ', score)
        if (this.hasAllScoreSelect(score)) {
          this.$emit('on-score-change', score)
        }
      }
    },
    onQuestItemListDataChange (hasChange) {
      if (hasChange) {
        this.hasDataChange = true
      }
    },
    onSubmit () {
      if (!this.hasDataChange) {
        this.toastText = '未修改数据，不用提交'
        this.showToast = true
        return
      }
      if (!this.validate()) {
        this.toastText = '未完成选择或填写'
        this.showToast = true
        return
      }
      this.showLoading = true
      this.submitDisabled = true
      const patientId = getStorageItem('patientId')
      this.patientId = patientId
      this.$http.post(`${this.httpRoot}/followup/data/update`, {
        followupId: this.questId,
        collection: this.collection,
        modelId: this.modelId,
        valueId: this.valueId,
        itemData: this.questItemData,
        patientId: patientId
      }, authenticate())
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          this.showLoading = false
          if (res.valueId) {
            this.updateValueId(res.valueId, this.modelId, this.questId)
          }
          if (!this.$refs.sselectShow) {
            this.hasSubmitSuccess = true
            this.submitDisabled = false
            this.toastType = 'success'
            this.toastText = '提交成功'
            this.showToast = true
          }
        } else {
          this.hasSubmitSuccess = false
          this.submitDisabled = false
          this.toastType = 'warn'
          this.toastText = '提交失败'
          this.showToast = true
        }
      })
      .catch(err => {
        this.showLoading = false
        catchExpired(err, this)
      })
      if (this.$refs.sselectShow) {
        this.$refs.sselectShow.forEach(ss => {
          ss.submitQuestLists(() => {
            this.hasSubmitSuccess = true
            this.submitDisabled = false
            this.toastType = 'success'
            this.toastText = '提交成功'
            this.showToast = true
          }, () => {
            this.hasSubmitSuccess = false
            this.submitDisabled = false
            this.toastType = 'warn'
            this.toastText = '提交失败'
            this.showToast = true
          })
        })
      }
    },
    updateValueId (valueId, modelId, questId) {
      this.valueId = valueId
      const followupItems = getStorageItem('followupItems_' + questId) || []
      followupItems.forEach(item => {
        if (item.modelId === modelId) {
          item.valueId = valueId
        }
      })
      updateStorageItem('followupItems_' + questId, followupItems)
    },
    getValueIdFromCache (modelId, questId) {
      let valueId = ''
      const followupItems = getStorageItem('followupItems_' + questId) || []
      followupItems.forEach(item => {
        if (item.modelId === modelId) {
          valueId = item.valueId
        }
      })
      return valueId
    },
    getQuestItemByKey (key) {
      let _item
      this.questItemList.forEach(item => {
        if (item.key === key) {
          _item = item
        }
      })
      return _item
    },
    getScore () {
      let score = []
      Object.keys(this.questItemData || {}).forEach(key => {
        const item = this.getQuestItemByKey(key)
        if (item && item.fieldType === 'score') {
          score.push({'v': Number(this.questItemData[key].value), 'i': Number(this.questItemData[key].scoreIndex || '')})
        }
      })
      return score
    },
    hasAllScoreSelect (score) {
      let modelScoreCount = 0
      this.questItemList.forEach(item => {
        if (item.fieldType === 'score') {
          modelScoreCount++
        }
      })
      if (score.length === modelScoreCount) {
        return true
      }
      return false
    },
    validate () {
      let result = true
      if (this.$refs.input) {
        this.$refs.input.forEach(item => {
          if (!item.validate()) {
            result = false
          }
        })
      }
      if (this.$refs.sselectShow) {
        this.$refs.sselectShow.forEach(item => {
          if (!item.validate()) {
            result = false
          }
        })
      }
      if (this.$refs.sselect) {
        this.$refs.sselect.forEach(item => {
          if (!item.validate()) {
            result = false
          }
        })
      }
      if (this.$refs.mselect) {
        this.$refs.mselect.forEach(item => {
          if (!item.validate()) {
            result = false
          }
        })
      }
      if (this.$refs.mselectInput) {
        this.$refs.mselectInput.forEach(item => {
          if (!item.validate()) {
            result = false
          }
        })
      }
      return result
    }
  },
  components: {
    YHeader,
    YButton,
    YProgress,
    Toast,
    Confirm,
    Loading,
    QuestItemInput,
    QuestItemSselect,
    QuestItemSselectShow,
    QuestItemMselect,
    QuestItemMselectInput,
    QuestItemShow
  }
}
</script>
<style lang="css">
.submit-footer {
  padding: 15px;
}
</style>
